import { useState, useEffect, useRef } from "react";
import { fetchData } from "../helper/api.interceptor";

const PositionSelector = ({ selected, setSelected }) => {
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const debounceRef = useRef(null);

    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (!query.trim()) {
            setSuggestions([]);
            return;
        }

        debounceRef.current = setTimeout(async () => {
            try {
                const res = await fetchData.get(`api/searchPosition?q=${encodeURIComponent(query)}`);
                setSuggestions(res?.positions || []);
            } catch (err) {
                console.error("Error searching positions:", err);
                setSuggestions([]);
            }
        }, 300);

        return () => clearTimeout(debounceRef.current);
    }, [query]);

    const addToSelected = (title) => {
        if (!selected.includes(title)) {
            setSelected([...selected, title]);
        }
        setQuery("");
        setSuggestions([]);
        setShowDropdown(false);
    };

    const handleAddNew = async () => {
        const title = query.trim();
        if (!title) return;
        try {
            const res = await fetchData.post("/api/addPosition", { title });
            if (res?.success) {
                addToSelected(res.position);
            }
        } catch (err) {
            console.error("Error adding new position:", err);
        }
    };

    const removeSelected = (title) => {
        setSelected(selected.filter((p) => p !== title));
    };

    const exactMatch = suggestions.some(
        (s) => s.toLowerCase() === query.trim().toLowerCase()
    );

    return (
        <div className="position-selector">
            <div className="d-flex flex-wrap gap-2 mb-2">
                {selected.map((pos) => (
                    <span key={pos} className="badge bg-light text-dark px-3 py-2">
                        {pos}
                        <button
                            type="button"
                            className="btn-close btn-close-sm ms-2"
                            onClick={() => removeSelected(pos)}
                        />
                    </span>
                ))}
            </div>

            <input
                type="text"
                className="form-control"
                placeholder="Type a position..."
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
            />

            {showDropdown && query.trim() && (
                <div className="dropdown-menu d-block position-relative mt-1 w-100">
                    {suggestions.map((s) => (
                        <button
                            type="button"
                            key={s}
                            className="dropdown-item"
                            onClick={() => addToSelected(s)}
                        >
                            {s}
                        </button>
                    ))}

                    {!exactMatch && (
                        <button
                            type="button"
                            className="dropdown-item text-primary"
                            onClick={handleAddNew}
                        >
                            + Add "{query.trim()}" as new position
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default PositionSelector;